// Color themes for the view page
const colorThemes = {
  default: { background: '#FDFCF8', foreground: '#18181B', cardBg: '#FFFFFF', secondary: '#F4F4F5', primary: '#E4E4E7' },
  pink: { background: '#FDF2F8', foreground: '#18181B', cardBg: '#FFFFFF', secondary: '#FCE7F3', primary: '#F9A8D4' },
  blue: { background: '#EFF6FF', foreground: '#18181B', cardBg: '#FFFFFF', secondary: '#DBEAFE', primary: '#93C5FD' },
  green: { background: '#F0FDF4', foreground: '#18181B', cardBg: '#FFFFFF', secondary: '#DCFCE7', primary: '#86EFAC' },
  purple: { background: '#FAF5FF', foreground: '#18181B', cardBg: '#FFFFFF', secondary: '#F3E8FF', primary: '#C4B5FD' },
  yellow: { background: '#FEFCE8', foreground: '#18181B', cardBg: '#FFFFFF', secondary: '#FEF9C3', primary: '#FDE047' },
  orange: { background: '#FFF7ED', foreground: '#18181B', cardBg: '#FFFFFF', secondary: '#FFEDD5', primary: '#FDBA74' },
  red: { background: '#FEF2F2', foreground: '#18181B', cardBg: '#FFFFFF', secondary: '#FEE2E2', primary: '#FCA5A5' },
  teal: { background: '#F0FDFA', foreground: '#18181B', cardBg: '#FFFFFF', secondary: '#CCFBF1', primary: '#5EEAD4' },
  slate: { background: '#F8FAFC', foreground: '#18181B', cardBg: '#FFFFFF', secondary: '#F1F5F9', primary: '#CBD5E1' },
};

export const getTheme = (themeId) => {
  const colors = colorThemes[themeId] || colorThemes.default;
  return { colors };
};
